import { useEffect } from "react";

const useClickOutside = (ref, handler, when = true) => {
  useEffect(() => {
    if (!when) return;
    function handleClick(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [ref, handler, when]);
};

export default useClickOutside;